import {Dispatch, FC, SetStateAction, useEffect, useMemo, useRef, useState} from 'react'
import {
  Invoice,
  InvoiceDiscountForm,
  InvoicePaymentForm,
  InvoicePaymentTypeItems,
  InvoiceRowForm,
  InvoiceTypeList,
  PaymentTaxRegistrationState,
} from '../core/_models'
import {
  getPaymentsToRegister,
  getPaymentTaxRegistrationBadge,
  paymentRegistrationKey,
  sumPaymentRegisteredAmounts,
  toPaymentTaxRegistration,
} from '../core/paymentTaxRegistration'
import {Step1} from './steps/Step1'
import {Stepper} from '../../../../../../_metronic/helpers/components/Stepper'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import {
  API_URL,
  isNotEmpty,
  numberWithCommas,
  projectName,
} from '../../../../../../_metronic/helpers'
import axios from 'axios'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {useListView} from '../core/ListViewProvider'
import {Alert} from '../../../../../../_metronic/helpers/components/Alert'
import {UploadedFile} from '_metronic/helpers/components/uploadTypes'
import {Step4} from './steps/Step4'
import {Console} from 'console'
import {SearchSelectOption} from '../../../../../../_metronic/helpers/components/SearchSelect'
import {useAuth} from '../../../../auth'
import {
  getDriverIdCodeValidationError,
  getInvoicePatternValidationError,
  hasInvoiceItemVatRateOverride,
  isZeroVatInvoiceTemplate,
  normalizeInvoicePatternItems,
} from '../core/invoicePatternValidation'
import {getInvoiceErrorAppLogId, getInvoiceErrorMessage} from '../core/invoiceError'
import {
  InvoiceSubject,
  isReferralInvoiceSubject,
  isValidReferenceTaxId,
  normalizeInvoiceSubject,
  resolveEffectiveInvoiceSubject,
} from '../core/invoiceSubject'
import {InvoiceSubjectSelector} from './InvoiceSubjectSelector'
import {InvoiceCancellationPanel} from './InvoiceCancellationPanel'
import {ProformaFormFields} from './ProformaFormFields'
import {ServiceFeeLine} from '../../../../business-services/components/ServiceFeeLine'
import {isProformaInvoice, opensNewProforma} from '../core/invoiceProforma'
import {getProformaSettings, getProformaSettingsQueryKey} from '../core/proformaRequests'
import {shiftPersianDay} from '../../../tax-workspace/core/tehranDate'
import {useQuery} from 'react-query'
import {TaxFolderPdfConfirmResult, TaxFolderReferenceCandidate} from '../core/_requests'
import {ICompanyTaxid} from '../../../taxpayer-management/taxpayers-setting/_models'
import {resolveFiscalMemorySelection} from '../core/fiscalMemorySelection'
import {isInvoiceBuyerRequired} from '../core/invoiceBuyerRequirement'
import {getWebFormEntryType, resolveInvoiceAutoSendControlValue} from '../core/invoiceAutoSend'
import {useInvoiceAutoSendDefault} from '../core/useInvoiceAutoSendDefault'
import {
  getInvoiceFieldRule,
  getOutOfPatternFieldsWithValues,
  hasOrganizationUnitCode,
  resolveInvoiceUnitRule,
  useInvoiceRulesV79,
} from '../core/invoiceRulesV79'
import {InvoiceRulesV79Panel} from './InvoiceRulesV79Panel'
import {WebInvoiceErrorSupportAction} from '../components/WebInvoiceErrorSupportAction'
import {
  FieldHelpLabel,
  FieldHelpResolverScope,
} from '../../../../../../_metronic/helpers/components/FieldHelp'
import {createInvoiceFieldHelpResolver} from '../core/invoiceFieldHelpCatalog'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import {
  InvoiceArticle9IssueDateAccessory,
  InvoiceArticle9RegistrationField,
} from '../components/InvoiceArticle9Fields'
import {
  article9UnixMillisecondsToDateTime,
  buildInvoiceArticle9Request,
  getInvoiceArticle9DraftError,
} from '../core/invoiceArticle9'
import {
  getReferencedInvoiceMinimumDate,
  REFERENCED_INVOICE_DATE_HINT,
} from '../core/invoiceReferenceDate'
import {IRAN_SHIPMENT_COUNTRY_CODE, isShipmentLocationValid} from '../core/shipmentLocationCodes'
import {
  applyReturnQuantitiesToInvoiceRows,
  calculateRemainingInvoiceQuantity,
  getPositiveReturnQuantityRows,
  getSalesReturnQuantityError,
} from '../core/invoiceQuantity'
import {
  getTemplate11CashError,
  getTemplate11RowsError,
  isTemplate11,
  TEMPLATE_11_ALLOWED_SUBJECTS,
  toTemplate11SubmitRow,
} from '../core/invoiceTemplate11'
import {unitLabelOf} from '../core/invoiceUnitCode'
import {loadedRowCurrency} from '../core/invoiceRowCurrency'
import {getGeneralDiscountChange, getLoadedGeneralDiscount} from '../core/invoiceGeneralDiscount'

const INVOICE_URL = `${API_URL}/invoices`

// نتیجهٔ ثبت پرداخت‌ها در سامانه مؤدیان (GET invoices/payment-registrations/{hash})
type PaymentRegistrationRowResult = {
  id: number
  type: number
  price: number
  datetime?: string
  traceNo?: string
  status?: number
  code?: string
  message?: string
  at?: string
  registrationId?: number
  registeredAmount?: number
  locked: boolean
}

type PaymentRegistrationResult = {
  hash: string
  rows: PaymentRegistrationRowResult[]
  registered: number
  queued: number
  rejected: number
  unknown: number
  exhausted: number
  notApplicable: number
}

type props = {
  invoice: Invoice | null | undefined
  invoiceType: number
  invoiceTemplate: number
  title: {
    title: string
    setTitle: Dispatch<SetStateAction<string>>
  }
  closeFn?: () => void
  formType: number
}

const InvoiceForm: FC<props> = ({
  invoiceType: _invoiceType,
  invoiceTemplate: _invoiceTemplate,
  title,
  invoice,
  closeFn,
  formType,
}) => {
  const {currentUser} = useAuth()
  const autoSendEntryType = getWebFormEntryType(formType)
  const {defaultAutoSend} = useInvoiceAutoSendDefault(autoSendEntryType, currentUser?.cpi)
  const valueAddedNotCalled =
    currentUser?.cpl?.find((company) => company.id == currentUser.cpi)?.vnc == true
  const {refetch} = useQueryResponse()
  const {state: queryState, updateState: updateQueryState} = useQueryRequest()
  const {
    itemIdForUpdate,
    setItemIdForUpdate,
    variableB,
    variableD,
    setvariableD,
    setvariableA,
    newProforma,
  } = useListView()
  const [lastDiscountSum, setLastDiscountSum] = useState<number>(0)
  const [discountAlreadyInRows, setDiscountAlreadyInRows] = useState<number>(0)
  const [discountInColumn, setDiscountInColumn] = useState<number>(0)
  // تا این مبلغ عوض نشود، تخفیف درصدی همان مبلغی می‌ماند که ذخیره شده است.
  const loadedDiscountBase = useRef<number | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [first, setFirst] = useState(true)
  const [ebtalModal, setEbtalModal] = useState(false)
  const [ebtalNewModal, setEbtalNewModal] = useState(false)
  const [modifyModal, setModifyModal] = useState(false)
  // ثبت پرداخت در سامانه مؤدیان: تأیید پیش از ذخیره، نتیجه پس از آن، و تلاش مجدد یک ردیف
  const [paymentRegistrationConfirm, setPaymentRegistrationConfirm] = useState<
    {execute: boolean; confirm: boolean; save: boolean} | undefined
  >(undefined)
  const [paymentRegistrationResult, setPaymentRegistrationResult] = useState<
    PaymentRegistrationResult | undefined
  >(undefined)
  // پس از تأیید تا رسیدن نتیجه: کاربر باید ببیند ذخیره و ثبت در سامانه در جریان است
  const [paymentRegistrationProgress, setPaymentRegistrationProgress] = useState<
    {count: number; amount: number; registeredAmount: number} | undefined
  >(undefined)
  const [retryingRegistrationId, setRetryingRegistrationId] = useState<number | undefined>(
    undefined
  )
  useEffect(() => {
    if (!loading) setPaymentRegistrationProgress(undefined)
  }, [loading])
  const [loadedPaymentKeys, setLoadedPaymentKeys] = useState<Map<number, string>>(new Map())
  const [errorAppLogId, setErrorAppLogId] = useState<number>()
  const [isNew, setIsNew] = useState(false)
  const [invoiceSubject, setInvoiceSubject] = useState<InvoiceSubject>(() =>
    normalizeInvoiceSubject(invoice?.sbji)
  )
  const [referenceTaxId, setReferenceTaxId] = useState('')
  const [referenceOwnershipValid, setReferenceOwnershipValid] = useState(true)
  const [fiscalMemories, setFiscalMemories] = useState<ICompanyTaxid[]>([])
  const [fiscalMemoryId, setFiscalMemoryId] = useState<number | undefined>(invoice?.fmi)
  const [isProductionEnvironment, setIsProductionEnvironment] = useState(true)

  const [no, setNo] = useState<string>('')
  const [date, setDate] = useState<string>('')
  const [isArticle9, setIsArticle9] = useState(invoice?.insr === 1)
  const [article9RegistrationDateTime, setArticle9RegistrationDateTime] = useState(() =>
    article9UnixMillisecondsToDateTime(invoice?.indati2m)
  )
  const [invoiceType, setInvoiceType] = useState<number>(_invoiceType)
  const [invoiceTemplate, setInvoiceTemplate] = useState<number>(_invoiceTemplate)
  const [buyer, setBuyer] = useState<string>('')
  const [buyerDescription, setBuyerDescription] = useState<string>('')
  const [contractCode, setContractCode] = useState<string>('')
  const [declarationNo, setDeclarationNo] = useState<string>('')
  const [officeCode, setOfficeCode] = useState<string>('')
  const [billNo, setBillNo] = useState<string>('')
  const [cottageNo, setCottageNo] = useState<string>('')
  const [cottageDate, setCottageDate] = useState<string>('')
  const [saleAnnNo, setSaleAnnNo] = useState<string>('')
  const [saleAnnDate, setSaleAnnDate] = useState<string>('')
  const [insPolicyNo, setInsPolicyNo] = useState<string>('')
  const [extInsPolicyNo, setExtInsPolicyNo] = useState<string>('')
  const [flightType, setFlightType] = useState<string>('1')
  const [flightBuyerMethod, setFlightBuyerMethod] = useState<string>('1')
  const [flightNationalId, setFlightNationalId] = useState<string>('')
  const [flightForeignId, setFlightForeignId] = useState<string>('')
  const [flightPassportNumber, setFlightPassportNumber] = useState<string>('')
  const [flightFirstName, setFlightFirstName] = useState<string>('')
  const [flightLastName, setFlightLastName] = useState<string>('')
  const [flightEconomicCode, setFlightEconomicCode] = useState<string>('')
  const [flightAgentName, setFlightAgentName] = useState<string>('')
  const [flightAgentEconomicCode, setFlightAgentEconomicCode] = useState<string>('')
  const [shipmentBlNumber, setShipmentBlNumber] = useState<string>('')
  const [shipmentRefBlNumber, setShipmentRefBlNumber] = useState<string>('')
  const [shipmentOriginCountry, setShipmentOriginCountry] = useState<string>(IRAN_SHIPMENT_COUNTRY_CODE)
  const [shipmentOriginCity, setShipmentOriginCity] = useState<string>('')
  const [shipmentDestinationCountry, setShipmentDestinationCountry] = useState<string>(IRAN_SHIPMENT_COUNTRY_CODE)
  const [shipmentDestinationCity, setShipmentDestinationCity] = useState<string>('')
  const [shipmentSenderEconomicCode, setShipmentSenderEconomicCode] = useState<string>('')
  const [shipmentReceiverEconomicCode, setShipmentReceiverEconomicCode] = useState<string>('')
  const [shipmentTransportType, setShipmentTransportType] = useState<string>('1')
  const [shipmentFleetNumber, setShipmentFleetNumber] = useState<string>('')
  const [shipmentDriverIdCode, setShipmentDriverIdCode] = useState<string>('')
  const [shipmentTotalWeight, setShipmentTotalWeight] = useState<string>('')

  const [items, setItems] = useState<InvoiceRowForm[]>([])
  const [discounts, setDiscounts] = useState<InvoiceDiscountForm[]>([])

  const [settlement, setSettlement] = useState<string>('1')
  // الگوی ۱۱: پرداخت‌ها خارج از الگو هستند؛ برای روش تسویه ۳ فقط سهم نقدی (cap) گرفته می‌شود
  const [cash, setCash] = useState<string>('')
  const template11 = isTemplate11(invoiceType, invoiceTemplate)

  const [payments, setPayments] = useState<InvoicePaymentForm[]>([])
  const [totalVatRate, setTotalVatRate] = useState<number>(0)
  const [tax17, setTax17] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [note1, setNote1] = useState<string>('')
  const [note2, setNote2] = useState<string>('')
  const [files, setFiles] = useState<UploadedFile[]>([])

  const [validate1, setValidate1] = useState(false)
  const [validate2, setValidate2] = useState(false)
  const [validate3, setValidate3] = useState(false)
  const [validateReturn, setValidateReturn] = useState(false)

  const [updateItemsKey, setUpdateItemsKey] = useState(1)
  const [returnQty, setReturnQty] = useState<InvoiceRowForm[]>([])

  const [errorModal, setErrorModal] = useState('')

  const [isSend, setIsSend] = useState(false)
  const [autoSendTouched, setAutoSendTouched] = useState(false)
  const [vatCheck, setVatCheck] = useState('1')

  const [printTemplate, setPrintTemplate] = useState<number>()

  const displayedIsSend = resolveInvoiceAutoSendControlValue(
    invoice?.id ? undefined : defaultAutoSend,
    isSend,
    autoSendTouched
  )

  const setIsSendFromControl: Dispatch<SetStateAction<boolean>> = (value) => {
    setAutoSendTouched(true)
    setIsSend(value)
  }

  const [now, setNow] = useState('')
  // «پیش‌فاکتور»: an existing proforma, or a new one the list's «پیش‌فاکتور جدید» opened; any other
  // new document is an invoice (phase 1). A proforma is always an original (subject 1), takes no
  // fiscal memory, payment, send or article 9, and has a validity.
  const isProformaForm =
    isProformaInvoice(invoice) ||
    (opensNewProforma({newProforma, itemIdForUpdate, referralAction: variableD}) && !invoice?.id)
  const [proformaValidUntil, setProformaValidUntil] = useState<string>(invoice?.prf?.vu || '')
  const [proformaPaymentTerms, setProformaPaymentTerms] = useState<string>(invoice?.prf?.pt || '')
  const [proformaDeliveryTerms, setProformaDeliveryTerms] = useState<string>(
    invoice?.prf?.dt || ''
  )
  const {data: proformaSettings} = useQuery(
    getProformaSettingsQueryKey(Number(currentUser?.cpi || 0)),
    () => getProformaSettings(Number(currentUser?.cpi || 0)),
    {enabled: isProformaForm && Number(currentUser?.cpi || 0) > 0, refetchOnWindowFocus: false}
  )
  const proformaValid = !isProformaForm || isNotEmpty(proformaValidUntil)
  const isNewSubjectFlow =
    !isProformaForm && !invoice?.id && itemIdForUpdate == null && variableD == undefined
  const effectiveSubject = resolveEffectiveInvoiceSubject(variableD, invoiceSubject)
  const isReferralInvoice = isReferralInvoiceSubject(effectiveSubject)
  // Its fee shows for a new referral only: saving its own unsent draft again is the same referral (2026-10-18).
  const editsOwnReferralDraft = Boolean(invoice?.id) && invoice?.sbji === effectiveSubject && invoice?.ph?.i === 1
  const referralFee =
    isReferralInvoice && !editsOwnReferralDraft
      ? effectiveSubject === 2
        ? {feature: 'referralCorrection', each: 'این صورتحساب اصلاحی'}
        : effectiveSubject === 3
        ? {feature: 'referralCancellation', each: 'این صورتحساب ابطالی'}
        : {feature: 'referralReturn', each: 'این برگشت از فروش'}
      : undefined
  const minimumReferenceDate = getReferencedInvoiceMinimumDate(invoice, variableD)
  const {
    rules: invoiceRules,
    loading: invoiceRulesLoading,
    error: invoiceRulesError,
  } = useInvoiceRulesV79({
    invoiceType,
    invoicePattern: invoiceTemplate,
    invoiceSubject: effectiveSubject,
    isArticle9,
    settlementMethod: Number(settlement) || undefined,
    buyerType: invoice?.but,
  })
  const article9DraftError = getInvoiceArticle9DraftError(
    isArticle9,
    invoiceType,
    article9RegistrationDateTime,
    date,
    now
  )
  const article9Request = buildInvoiceArticle9Request(
    isArticle9,
    invoiceType,
    article9RegistrationDateTime
  )
  const activeRowPolicy = invoiceRules?.enabled ? invoiceRules.rowPolicy : undefined
  const fieldHelpResolver = useMemo(
    () => createInvoiceFieldHelpResolver(invoiceRules),
    [invoiceRules]
  )
  const unitRule = resolveInvoiceUnitRule(
    invoiceRules,
    invoiceType,
    invoiceTemplate,
    effectiveSubject
  )
  const previousRuleContext = useRef<string | undefined>(undefined)
  const serializeRuleField = (jsonName: string, value: unknown) => {
    if (!invoiceRules?.enabled) return value
    return getInvoiceFieldRule(invoiceRules, jsonName)?.shouldSerialize === true ? value : undefined
  }
  useEffect(() => {
    if (first || !invoiceRules?.enabled) return

    const contextKey = [
      invoiceRules.instructionVersion,
      invoiceType,
      invoiceTemplate,
      effectiveSubject,
      settlement,
    ].join(':')
    const previousContext = previousRuleContext.current
    previousRuleContext.current = contextKey
    if (!previousContext || previousContext === contextKey) return

    const controlledFields = [
      {jsonName: 'crn', value: contractCode, clear: () => setContractCode('')},
      {jsonName: 'scln', value: declarationNo, clear: () => setDeclarationNo('')},
      {jsonName: 'scc', value: officeCode, clear: () => setOfficeCode('')},
      {jsonName: 'billid', value: billNo, clear: () => setBillNo('')},
      {jsonName: 'cdcn', value: cottageNo, clear: () => setCottageNo('')},
      {jsonName: 'cdcd', value: cottageDate, clear: () => setCottageDate('')},
      {jsonName: 'asn', value: saleAnnNo, clear: () => setSaleAnnNo('')},
      {jsonName: 'asd', value: saleAnnDate, clear: () => setSaleAnnDate('')},
      {jsonName: 'in', value: insPolicyNo, clear: () => setInsPolicyNo('')},
      {jsonName: 'an', value: extInsPolicyNo, clear: () => setExtInsPolicyNo('')},
      {jsonName: 'nti1', value: note1, clear: () => setNote1('')},
      {jsonName: 'nti2', value: note2, clear: () => setNote2('')},
      {jsonName: 'tax17', value: tax17, clear: () => setTax17('')},
    ]
    const values = controlledFields.reduce<Record<string, unknown>>((result, field) => {
      result[field.jsonName] = field.value
      return result
    }, {})
    const invalidFields = getOutOfPatternFieldsWithValues(values, invoiceRules)
    if (invalidFields.length === 0) return

    const fieldList = invalidFields
      .map((field) => `${field.titleFa} (${field.jsonName})`)
      .join('\n')
    if (
      window.confirm(
        `با تغییر قواعد صورتحساب، فیلدهای زیر خارج از الگو شده‌اند و در ارسال حذف می‌شوند:\n${fieldList}\n\nآیا مقدارهای واردشده پاک شوند؟`
      )
    ) {
      const invalidNames = new Set(invalidFields.map((field) => field.jsonName))
      controlledFields
        .filter((field) => invalidNames.has(field.jsonName))
        .forEach((field) => field.clear())
    }
  }, [
    billNo,
    contractCode,
    cottageDate,
    cottageNo,
    declarationNo,
    effectiveSubject,
    extInsPolicyNo,
    first,
    insPolicyNo,
    invoiceRules,
    invoiceTemplate,
    invoiceType,
    note1,
    note2,
    officeCode,
    saleAnnDate,
    saleAnnNo,
    settlement,
    tax17,
  ])
  const enabledOrBoundFiscalMemories = useMemo(
    () => fiscalMemories.filter((token) => token.isEnabled !== false || token.id === invoice?.fmi),
    [fiscalMemories, invoice?.fmi]
  )
  const availableFiscalMemories = enabledOrBoundFiscalMemories
  const selectedFiscalMemory = resolveFiscalMemorySelection(
    availableFiscalMemories,
    fiscalMemoryId,
    isProductionEnvironment
  )
  const effectiveFiscalMemoryId = selectedFiscalMemory?.id
  const effectiveIsProductionEnvironment = selectedFiscalMemory
    ? selectedFiscalMemory.isActive !== false
    : isProductionEnvironment
  const referenceIsValid =
    effectiveSubject === 1 ||
    (!isNewSubjectFlow ? true : isValidReferenceTaxId(referenceTaxId) && referenceOwnershipValid)

  useEffect(() => {
    axios
      .get(`${API_URL}/taxpayer/fiscalIds`)
      .then(({data}) => {
        const all = (data || []) as ICompanyTaxid[]
        setFiscalMemories(all)
        const boundToken = all.find((token) => token.id === invoice?.fmi)
        const targetEnvironment = boundToken ? boundToken.isActive !== false : true
        setIsProductionEnvironment(targetEnvironment)
      })
      .catch(() => setErrorModal('دریافت شناسه‌های حافظه مالیاتی ناموفق بود.'))
  }, [])

  useEffect(() => {
    if (!selectedFiscalMemory || selectedFiscalMemory.id === fiscalMemoryId) {
      return
    }

    setFiscalMemoryId(selectedFiscalMemory.id)
    setIsProductionEnvironment(selectedFiscalMemory.isActive !== false)
  }, [fiscalMemoryId, selectedFiscalMemory])

  const getItem = (rw: InvoiceRowForm) => {
    if (!first && returnQty && variableD == 4) {
      const finded = returnQty.find((x) => x.id == rw.id)
      if (finded) {
        return finded
      }
    }
    return rw
  }

  const getSumPrice: () => number = () => {
    let sum = 0
    items.map((rw) => {
      sum += getItem(rw).price || 0
    })
    return sum
  }
  const getSumItemDiscount = () => {
    let sum = 0
    items.map((rw) => {
      sum += getItem(rw).discount || 0
    })
    return sum
  }
  const getSumDiscount: () => number = () => {
    let sum = 0
    if (discounts && !template11) {
      discounts.map((rw) => {
        sum += rw.price || 0
      })
    }
    return sum
  }
  const getExtraSum: () => number = () => {
    let sum = 0
    if (invoiceTemplate == 3) {
      items.map((rw) => {
        sum += getItem(rw).wage || 0
        sum += getItem(rw).profit || 0
        sum += getItem(rw).commission || 0
      })
    }
    return sum
  }
  const getSumItemTotalDiscount = () => {
    let sum = 0
    items.map((rw) => {
      sum += getItem(rw).totalDiscount || 0
    })
    return sum
  }
  const getSumAdPrice: () => number = () => {
    return getSumPrice() - getSumItemDiscount() - getSumItemTotalDiscount() + getExtraSum()
  }
  const getSumAdPriceEXDiscount: () => number = () => {
    return getSumPrice() - getSumItemDiscount()
  }
  const getSumVatPrice: () => number = () => {
    let sum = 0
    items.map((rw) => {
      sum += getItem(rw).vatPrice || 0
    })
    return sum
  }
  const getSumTaxPrice: () => number = () => {
    let sum = 0
    return sum
  }
  const getSumNetPrice: () => number = () => {
    let sum = 0
    sum = getSumAdPrice() + getSumVatPrice() + getSumTaxPrice()
    return sum
  }
  const S = (v: unknown) => (v == null ? '' : String(v))

  const getTotalVatRate = () => {
    setTotalVatRate(
      getSumNetPrice() == 0 || getSumVatPrice() == 0 ? 0 : getSumVatPrice() / getSumNetPrice()
    )
  }
  useEffect(() => {
    getTotalVatRate()
  }, [updateItemsKey])

  useEffect(() => {
    validation()
    if (first) {
      setTitle()
      if (invoice && invoice.id) {
        setNo(invoice.no || '')
        setDate(invoice.idt || '')
        setIsArticle9(invoice.insr === 1)
        setArticle9RegistrationDateTime(article9UnixMillisecondsToDateTime(invoice.indati2m))
        setInvoiceType(invoice.typi || 1)
        setInvoiceTemplate(invoice.tmpi || 1)
        setBuyer(invoice.buci?.toString() || '')
        setBuyerDescription(invoice.bud || '')
        setContractCode(invoice.cnc || '')
        setDeclarationNo(invoice.dcno || '')
        setOfficeCode(invoice.ofc || '')
        setBillNo(invoice.bno || '')
        setCottageNo(invoice.ctno || '')
        setCottageDate(invoice.ctd || '')
        setSaleAnnNo(invoice.sanno || '')
        setSaleAnnDate(invoice.sandt || '')
        setInsPolicyNo(invoice.ipno || '')
        setExtInsPolicyNo(invoice.eipno || '')
        setFlightType(invoice.fltin?.flightType?.toString() || '1')
        setFlightBuyerMethod(invoice.fltin?.buyerMethod?.toString() || '1')
        setFlightNationalId(invoice.fltin?.nationalId || '')
        setFlightForeignId(invoice.fltin?.foreignId || '')
        setFlightPassportNumber(invoice.fltin?.passportNumber || '')
        setFlightFirstName(invoice.fltin?.firstName || '')
        setFlightLastName(invoice.fltin?.lastName || '')
        setFlightEconomicCode(invoice.fltin?.economicCode || '')
        setFlightAgentName(invoice.fltin?.agentName || '')
        setFlightAgentEconomicCode(invoice.fltin?.agentEconomicCode || '')
        setShipmentBlNumber(invoice.shpin?.blno || invoice.wbno || '')
        setShipmentRefBlNumber(invoice.shpin?.rblno || '')
        setShipmentOriginCountry(invoice.shpin?.orco || IRAN_SHIPMENT_COUNTRY_CODE)
        setShipmentOriginCity(invoice.shpin?.orci || '')
        setShipmentDestinationCountry(invoice.shpin?.dsco || IRAN_SHIPMENT_COUNTRY_CODE)
        setShipmentDestinationCity(invoice.shpin?.dsci || '')
        setShipmentSenderEconomicCode(invoice.shpin?.sneco || '')
        setShipmentReceiverEconomicCode(invoice.shpin?.rceco || '')
        setShipmentTransportType(invoice.shpin?.trtyp || '1')
        setShipmentFleetNumber(invoice.shpin?.flno || '')
        setShipmentDriverIdCode(invoice.shpin?.drcd || '')
        setShipmentTotalWeight(invoice.shpin?.ttw || '')
        setSettlement(invoice.stli?.toString() || '')
        const loadedTemplate11 = isTemplate11(invoice.typi || 1, invoice.tmpi || 1)
        if (loadedTemplate11 && invoice.stli == 3) {
          const loadedCash = parseFloat(S(invoice.csh ?? '').replace(/,/g, ''))
          setCash(Number.isFinite(loadedCash) && loadedCash > 0 ? loadedCash.toString() : '')
        }
        setPrintTemplate(invoice.ctmi || 0)
        setDescription(invoice.dsc || '')
        setNote1(invoice.nti1 || '')
        setNote2(invoice.nti2 || '')
        setTax17(invoice.tx17?.toString() || '')
        setFiles(invoice.fls || [])
        setTotalVatRate(invoice.tvr || 0)
        // الگوی ۱۱: پرداخت‌ها و تخفیف‌های کلی خارج از الگو هستند و بارگذاری/ارسال نمی‌شوند
        if (invoice.pym && !loadedTemplate11) {
          let _payments: InvoicePaymentForm[] = []
          const _loadedKeys = new Map<number, string>()
          // در «اصلاح» صورتحساب جدیدی صادر می‌شود و ردیف‌های پرداخت آزادند؛ در بقیهٔ حالت‌ها ردیفی که سازمان دارد قفل است
          const lockRegisteredRows = variableD !== 2
          invoice.pym.forEach((rw) => {
            const payment: InvoicePaymentForm = {
              id: rw.id || 0,
              description: rw.dsc || '',
              price: rw.prc || 0,
              cash: rw.csh || 0,
              vat: rw.vt || 0,
              date: rw.dt || '',
              type: (rw.typ || 0).toString(),
              refereceNo: rw.trc || '',
              traceNo: rw.trc || '',
              cardNo: rw.cno || '',
              payerId: rw.nid || '',
              payerNationalCode: rw.nid || '',
              switchNumber: rw.swno || rw.switchNumber || '',
              acquirerNumber: rw.aqno || rw.acquirerNumber || '',
              terminalNumber: rw.terno || rw.terminalNumber || '',
              files: rw.fl || [],
              taxValidationError: rw.txerr || rw.taxValidationError || '',
              locked: lockRegisteredRows && rw.lck === true,
              taxRegistration: toPaymentTaxRegistration(rw),
            }
            _payments.push(payment)
            if (payment.id > 0) {
              _loadedKeys.set(payment.id, paymentRegistrationKey(payment))
            }
          })
          setPayments([...[], ..._payments])
          setLoadedPaymentKeys(_loadedKeys)
        }
        if (invoice.tdis && !loadedTemplate11) {
          let _discounts: InvoiceDiscountForm[] = []
          invoice.tdis.forEach((rw) => {
            _discounts.push({
              id: rw.id || 0,
              description: rw.dsc || '',
              price: rw.prc || 0,
              rate: (rw.rt || 0).toString(),
              type: (rw.rt || 0) > 0 ? 'rate' : 'price',
            })
          })
          setDiscounts([...[], ..._discounts])
        }
        if (invoice.itm) {
          let _items: InvoiceRowForm[] = []
          invoice.itm.forEach((rw) => {
            const forceZeroVat =
              valueAddedNotCalled || isZeroVatInvoiceTemplate(invoice.tmpi || invoiceTemplate)
            const rowVatRate = forceZeroVat ? 0 : rw.vtr
            const rowVatPrice = forceZeroVat ? 0 : parseFloat(S(rw.vtp ?? '').replace(/,/g, ''))
            _items.push({
              product: {
                id: rw.sop.id,
                cd: rw.sop.cd,
                nm: rw.sop.nm,
                vtr: rowVatRate,
              },
              description: rw.dsc,
              amount: parseFloat(S(rw.amt ?? '').replace(/,/g, '')),
              qty: parseFloat(S(rw.qty ?? '').replace(/,/g, '')),
              price: parseFloat(S(rw.prc ?? '').replace(/,/g, '')),
              adPrice: parseFloat(S(rw.adp ?? '').replace(/,/g, '')),
              ...(loadedTemplate11 ? {adis: parseFloat(S(rw.adp ?? '').replace(/,/g, ''))} : {}),
              contractNo:
                rw.cnc != null && Number(rw.cnc) > 0
                  ? parseFloat(S(rw.cnc).replace(/,/g, ''))
                  : undefined,
              netPrice: parseFloat(S(rw.ntp ?? '').replace(/,/g, '')),
              vatPrice: rowVatPrice,
              discount: parseFloat(S(rw.dis ?? '').replace(/,/g, '')),
              ...(loadedTemplate11
                ? {}
                : {totalDiscount: parseFloat(S(rw.tdis ?? '').replace(/,/g, '')) || 0}),
              wage: rw.wge && rw.wge != null ? parseFloat(S(rw.wge ?? '').replace(/,/g, '')) : 0,
              commission:
                rw.comm && rw.comm != null ? parseFloat(S(rw.comm ?? '').replace(/,/g, '')) : 0,
              profit:
                rw.prft && rw.prft != null ? parseFloat(S(rw.prft ?? '').replace(/,/g, '')) : 0,
              carat:
                rw.cara && rw.cara != null ? parseFloat(S(rw.cara ?? '').replace(/,/g, '')) : 0,
              govTaxPrice: parseFloat(S(rw.gtp ?? '').replace(/,/g, '')),
              taxPrice: parseFloat(S(rw.txp ?? '').replace(/,/g, '')),
              govTaxName: rw.gtn,
              govTaxRate: rw.gtr,
              taxName: rw.txn,
              taxRate: rw.txr,
              productId: rw.sop.id,
              vatRate: rowVatRate,
              id: rw.id,
              unit: {
                label: unitLabelOf(rw.unt, rw.uni, rw),
                value: rw.uni,
              },
              ...loadedRowCurrency(rw),
              currencyRate:
                rw.adpr && rw.adpr != null
                  ? parseFloat(S(rw.adpr ?? '').replace(/,/g, ''))
                  : undefined,
              amountCurrency:
                rw.adpd && rw.adpd != null
                  ? parseFloat(S(rw.adpd ?? '').replace(/,/g, ''))
                  : undefined,
              currencyPurchaseRate:
                rw.adppr && rw.adppr != null
                  ? parseFloat(S(rw.adppr ?? '').replace(/,/g, ''))
                  : undefined,
              currencyValue:
                rw.curv && rw.curv != null
                  ? parseFloat(S(rw.curv ?? '').replace(/,/g, ''))
                  : undefined,
              vatBaseAmount: rw.vtbr || undefined,
              weight:
                rw.wei && rw.wei != null
                  ? parseFloat(S(rw.wei ?? '').replace(/,/g, ''))
                  : undefined,
            })
          })
          setItems([...[], ..._items])
          const loadedDiscount = getLoadedGeneralDiscount(
            _items,
            loadedTemplate11 ? [] : (invoice.tdis || []).map((rw) => ({price: rw.prc}))
          )
          setLastDiscountSum(loadedDiscount.sum)
          setDiscountAlreadyInRows(loadedDiscount.alreadyInRows)
          setDiscountInColumn(loadedDiscount.inDiscountColumn)
          loadedDiscountBase.current = loadedDiscount.base
        }

        setTitle()
      } else {
        // پیش‌فاکتور و صورتحساب شماره‌گذاری جدا دارند.
        axios
          .get(`${API_URL}/invoices/checkNo/`, {
            params: isProformaForm ? {proforma: true} : undefined,
          })
          .then((response) => {
            setNo(response.data)
          })
      }
      axios.get(`${API_URL}/taxpayer/getdatetime/`).then((response) => {
        setNow(response.data)
      })
      setFirst(false)
    }
  }, [])

  useEffect(() => {
    if (!(invoice && invoice.id)) {
      setDate(now)
    }
  }, [now])

  // A new proforma is valid for the business's default days after its issue day until the user picks.
  useEffect(() => {
    if (!isProformaForm || invoice?.id || !date || !proformaSettings) return
    setProformaValidUntil((current) =>
      current || shiftPersianDay(date.slice(0, 10), proformaSettings.defaultValidityDays)
    )
  }, [isProformaForm, invoice?.id, date, proformaSettings])

  useEffect(() => {
    if (invoiceType === 3 && isArticle9) {
      setIsArticle9(false)
    }
  }, [invoiceType, isArticle9])

  useEffect(() => {
    if (!first && isNewSubjectFlow) {
      setTitle()
    }
  }, [invoiceSubject])

  const setTitle = () => {
    let _title = ''
    const selectedType = InvoiceTypeList.find((x) => x.id == invoiceType)
    if (selectedType) {
      let name = selectedType.name
      if (selectedType.template) {
        name += ' - ' + selectedType.template.find((x) => x.id == invoiceTemplate)?.name
      }
      _title = name
    }
    if (variableD == 4) {
      _title = `برگشت از فروش صورتحساب ${no} ${date}`
    } else if (variableD == 2) {
      _title = `اصلاح ${_title} ${no} ${date}`
    } else if (variableD == 5) {
      _title = `عملیات پرداخت ${_title} ${no} ${date}`
    } else if (isProformaForm) {
      if (invoice && invoice.id) {
        _title = `ویرایش پیش‌فاکتور ${no} — ${_title}`
      } else {
        setIsNew(true)
        _title = `صدور پیش‌فاکتور — ${_title}`
      }
    } else {
      if (invoice && invoice.id) {
        _title = `ویرایش ${_title} ${no} ${date}`
      } else {
        setIsNew(true)
        _title = `صدور ${_title}`
      }
    }
    if (isNewSubjectFlow && invoiceSubject != 1) {
      const subjectTitle =
        invoiceSubject == 2 ? 'اصلاحی' : invoiceSubject == 3 ? 'ابطالی' : 'برگشت از فروش'
      _title += ` — ${subjectTitle}`
    }
    title.setTitle(_title)
  }

  useEffect(() => {
    validation()
    if (items.length > 0 && getSumNetPrice() == 0) {
      setSettlement('1')
    }
  }, [
    no,
    date,
    buyer,
    invoiceType,
    invoiceTemplate,
    items,
    settlement,
    payments,
    cash,
    returnQty,
    discounts,
    saleAnnNo,
    saleAnnDate,
    declarationNo,
    officeCode,
    billNo,
    cottageNo,
    cottageDate,
    insPolicyNo,
    extInsPolicyNo,
    flightType,
    flightBuyerMethod,
    flightNationalId,
    flightForeignId,
    flightPassportNumber,
    flightAgentEconomicCode,
    shipmentBlNumber,
    shipmentRefBlNumber,
    shipmentOriginCountry,
    shipmentOriginCity,
    shipmentDestinationCountry,
    shipmentDestinationCity,
    shipmentSenderEconomicCode,
    shipmentReceiverEconomicCode,
    shipmentTransportType,
    shipmentFleetNumber,
    shipmentDriverIdCode,
  ])

  useEffect(() => {
    if (getSumDiscount() != lastDiscountSum) {
      if (discounts && items.length > 0) {
        const discountChange = getGeneralDiscountChange(
          discounts,
          discountAlreadyInRows,
          discountInColumn
        )
        axios
          .post(`${INVOICE_URL}/CalculateDiscount`, {
            invoiceType: invoiceType,
            invoiceTemplate: invoiceTemplate,
            items: items,
            returnQty: returnQty,
            discounts: discountChange.discounts,
            generalDiscountTakeBack: discountChange.takeBack,
          })
          .then((response) => {
            const data = response.data.items as InvoiceRowForm[]
            let updItems: InvoiceRowForm[] = items
            data.forEach((element) => {
              let finded = updItems.find((x) => x.id == element.id)
              if (finded) {
                finded.discount = element.discount
                finded.totalDiscount = element.totalDiscount
                finded.adPrice = element.adPrice
                finded.vatPrice = element.vatPrice
                finded.netPrice = element.netPrice
              }
            })
            setItems([...[], ...updItems])

            const dataQty = response.data.returnQty as InvoiceRowForm[]
            let updQtys: InvoiceRowForm[] = returnQty
            dataQty.forEach((element) => {
              let finded = updQtys.find((x) => x.id == element.id)
              if (finded) {
                finded.discount = element.discount
                finded.totalDiscount = element.totalDiscount
                finded.adPrice = element.adPrice
                finded.vatPrice = element.vatPrice
                finded.netPrice = element.netPrice
              }
            })
            setReturnQty([...[], ...updQtys])
            setUpdateItemsKey(updateItemsKey + 1)
            setLastDiscountSum(getSumDiscount())
            setDiscountAlreadyInRows(discountChange.alreadyInRows)
            setDiscountInColumn(discountChange.inDiscountColumn)
          })
          .catch((error) => {
            setErrorModal(
              getInvoiceErrorMessage(error, 'محاسبه تخفیف کلی ناموفق بود. لطفاً دوباره تلاش کنید.')
            )
          })
      }
    }
  }, [discounts])

  useEffect(() => {
    if (
      discounts &&
      discounts.length > 0 &&
      getSumAdPriceEXDiscount() !== loadedDiscountBase.current
    ) {
      loadedDiscountBase.current = null
      discounts.forEach((element) => {
        if (element.type == 'rate') {
          element.price = Number(
            (getSumAdPriceEXDiscount() * (parseFloat(element.rate) / 100)).toFixed(0)
          )
        }
      })
      setDiscounts([...[], ...discounts])
    }
    setUpdateItemsKey(updateItemsKey + 1)
  }, [items])

  useEffect(() => {
    if (isNotEmpty(contractCode) && contractCode.length > 12) {
      setContractCode(contractCode.substring(0, 12))
    }
  }, [contractCode])

  useEffect(() => {
    if (isNotEmpty(saleAnnNo) && saleAnnNo.length > 30) {
      setSaleAnnNo(saleAnnNo.substring(0, 30))
    }
  }, [saleAnnNo])

  const getSumPayments = () => {
    let sum = 0
    payments.map((rw) => {
      sum += rw.price || 0
    })
    return sum
  }

  const getPatternValidationError = () =>
    getInvoicePatternValidationError(invoiceTemplate, items, activeRowPolicy)
  const showVatRateValidationQuestion =
    !valueAddedNotCalled &&
    !isZeroVatInvoiceTemplate(invoiceTemplate) &&
    hasInvoiceItemVatRateOverride(items)
  const isDigits = (value: string) => /^\d+$/.test((value || '').trim())
  const isEmptyOrDigits = (value: string) => !isNotEmpty(value) || isDigits(value)
  const validExact = (value: string, length: number, required = false) =>
    (!required && !isNotEmpty(value)) || (isDigits(value) && value.trim().length == length)
  const validRange = (value: string, min: number, max: number, required = false) =>
    (!required && !isNotEmpty(value)) ||
    (isDigits(value) && value.trim().length >= min && value.trim().length <= max)
  const validMax = (value: string, max: number, required = false) =>
    (!required && !isNotEmpty(value)) || (isDigits(value) && value.trim().length <= max)
  const validTextMax = (value: string, max: number, required = false) =>
    (!required && !isNotEmpty(value)) || value.trim().length <= max

  const validation = () => {
    console.log('validation...')
    let validate1_ = isNotEmpty(no)
    if (validate1_) {
      validate1_ = !isInvoiceBuyerRequired(invoiceType, invoiceTemplate) || isNotEmpty(buyer)
    }
    if (validate1_) {
      validate1_ = isNotEmpty(date)
    }
    if (validate1_ && invoiceType == 1 && invoiceTemplate == 4) {
      validate1_ = isNotEmpty(contractCode) && contractCode.length == 12
    }
    if (validate1_ && invoiceType == 1 && isNotEmpty(contractCode)) {
      validate1_ = contractCode.length == 12
    }
    if (validate1_ && isNotEmpty(declarationNo)) {
      validate1_ = validMax(declarationNo, 14)
    }
    if (validate1_ && isNotEmpty(officeCode)) {
      validate1_ = validExact(officeCode, 5)
    }
    if (validate1_ && invoiceTemplate == 5) {
      validate1_ = validMax(billNo, 19, true)
    }
    if (validate1_ && invoiceTemplate == 6) {
      validate1_ = ['1', '2'].includes(flightType)
      if (validate1_ && flightBuyerMethod == '1') {
        validate1_ = validExact(flightNationalId, 10, flightType == '1')
      } else if (validate1_ && flightBuyerMethod == '2') {
        validate1_ = validExact(flightForeignId, 12, flightType == '1')
      } else if (validate1_ && flightBuyerMethod == '3') {
        validate1_ = flightType != '1' && validTextMax(flightPassportNumber, 9, true)
      } else {
        validate1_ = false
      }
      if (validate1_ && isNotEmpty(flightEconomicCode)) {
        // Sent as header.tinb when no buyer is selected: 11 digits (legal) or 14 (natural).
        validate1_ =
          validExact(flightEconomicCode, 11, true) || validExact(flightEconomicCode, 14, true)
      }
      if (validate1_ && isNotEmpty(flightAgentEconomicCode)) {
        validate1_ = validRange(flightAgentEconomicCode, 11, 14)
      }
    }
    if (validate1_ && invoiceTemplate == 7) {
      validate1_ =
        validMax(cottageNo, 14) &&
        (!isNotEmpty(cottageDate) || isNotEmpty(cottageNo)) &&
        isEmptyOrDigits(cottageNo)
    }
    if (validate1_ && invoiceTemplate == 11) {
      const cleanSaleAnnNo = saleAnnNo.trim()
      validate1_ =
        isNotEmpty(cleanSaleAnnNo) &&
        cleanSaleAnnNo.length <= 30 &&
        isDigits(cleanSaleAnnNo) &&
        isNotEmpty(saleAnnDate)
    }
    if (validate1_ && invoiceTemplate == 13) {
      validate1_ = validRange(insPolicyNo, 9, 12, true) && validRange(extInsPolicyNo, 9, 12)
    }
    if (validate1_ && invoiceTemplate == 8) {
      validate1_ =
        validMax(shipmentBlNumber, 18, true) &&
        validMax(shipmentRefBlNumber, 18) &&
        isShipmentLocationValid(shipmentOriginCountry, shipmentOriginCity) &&
        isShipmentLocationValid(shipmentDestinationCountry, shipmentDestinationCity) &&
        validRange(shipmentSenderEconomicCode, 10, 12, true) &&
        validRange(shipmentReceiverEconomicCode, 10, 12, true) &&
        ['1', '2', '3', '4'].includes(shipmentTransportType) &&
        isNotEmpty(shipmentFleetNumber) &&
        shipmentFleetNumber.length <= 20 &&
        (shipmentTransportType != '1' || isNotEmpty(shipmentDriverIdCode)) &&
        getDriverIdCodeValidationError(shipmentDriverIdCode) === ''
    }
    setValidate1(validate1_)

    setValidate2(items.length > 0 && getSumNetPrice() >= 0 && getPatternValidationError() == '')
    setValidate3(
      isNotEmpty(settlement) &&
        settlement != '0' &&
        (template11
          ? getTemplate11CashError(settlement, cash, getSumNetPrice()) === ''
          : // پیش‌فاکتور پرداخت ندارد؛ نسیه و نقدی‌نسیه فقط شرط پیشنهادی آن است.
            settlement != '3' || payments.length > 0 || isProformaForm)
    )
    console.log('contractCode.length', contractCode.length)
    if (returnQty.length > 0) {
      let originalQuantity = 0
      let returnedQuantity = 0
      items.map((rw) => {
        originalQuantity += rw.qty ?? 0
      })
      returnQty.map((rw) => {
        returnedQuantity += rw.qty ?? 0
      })
      setValidateReturn(
        getPositiveReturnQuantityRows(returnQty).length > 0 &&
          calculateRemainingInvoiceQuantity(originalQuantity, returnedQuantity) > 0
      )
    } else {
      setValidateReturn(false)
    }
  }

  useEffect(() => {
    validation()
  }, [
    contractCode,
    saleAnnNo,
    saleAnnDate,
    declarationNo,
    officeCode,
    billNo,
    cottageNo,
    cottageDate,
    insPolicyNo,
    extInsPolicyNo,
    flightType,
    flightBuyerMethod,
    flightNationalId,
    flightForeignId,
    flightPassportNumber,
    flightAgentEconomicCode,
    shipmentBlNumber,
    shipmentRefBlNumber,
    shipmentOriginCountry,
    shipmentOriginCity,
    shipmentDestinationCountry,
    shipmentDestinationCity,
    shipmentSenderEconomicCode,
    shipmentReceiverEconomicCode,
    shipmentTransportType,
    shipmentFleetNumber,
    shipmentDriverIdCode,
  ])

  const getSumReturnQtyRemain = () => {
    return applyReturnQuantitiesToInvoiceRows(items, returnQty).reduce(
      (sum, row) => sum + (row.qty ?? 0),
      0
    )
  }

  const isCompleteSalesReturn =
    variableD === 4 && items.length > 0 && returnQty.length > 0 && getSumReturnQtyRemain() <= 0

  const openCancellationFromSalesReturn = () => {
    if (!invoice?.id) return

    setvariableA({
      invoiceId: invoice.id,
      isMobileView: variableB?.invoiceId === invoice.id && variableB?.isMobileView === true,
    })
    setItemIdForUpdate(undefined)
    setvariableD(undefined)
  }

  const getRowsForSubmit = (rows: InvoiceRowForm[]) =>
    template11
      ? // الگوی ۱۱: تخفیف خارج از الگوست؛ adis عیناً و مبلغ واحد سازگار با Backend قدیمی ارسال می‌شود
        rows.map(toTemplate11SubmitRow)
      : normalizeInvoicePatternItems(invoiceTemplate, rows).map((row) => ({
          ...row,
          discount: (row.discount || 0) + (row.totalDiscount || 0),
          totalDiscount: 0,
        }))

  // پرداخت‌هایی که با این ذخیره به سامانه مؤدیان فرستاده می‌شوند: فقط صورتحساب ارسال‌شدهٔ واجد شرایط،
  // خارج از «اصلاح» و «برگشت از فروش» که صورتحساب جدیدی صادر می‌کنند
  const paymentsToRegister =
    invoice?.pytx?.el === true && variableD !== 2 && variableD !== 4
      ? getPaymentsToRegister(payments, loadedPaymentKeys)
      : []
  // صورتحساب ارسال‌شده (خارج از اصلاح و برگشت که صورتحساب جدیدی می‌سازند): روش تسویه همان است که
  // به سامانه رفته و با جدول پرداخت تغییر نمی‌کند
  const settlementReadOnly = invoice?.pytx?.lk === true && variableD !== 2 && variableD !== 4
  // حافظهٔ مالیاتی چنین صورتحسابی هم ثابت است: از خود صورتحساب خوانده می‌شود، نه از فهرستی که شاید
  // هنوز نرسیده یا شناسه‌اش را ندارد
  const fiscalMemoryFromInvoice =
    !!invoice?.fmi && (settlementReadOnly || variableD === 5 || invoice.fmce === false)
  const fiscalMemoryIdForSave =
    effectiveFiscalMemoryId ?? (fiscalMemoryFromInvoice ? invoice?.fmi : undefined)
  const isProductionEnvironmentForSave = selectedFiscalMemory
    ? selectedFiscalMemory.isActive !== false
    : fiscalMemoryFromInvoice && invoice?.fme
    ? invoice.fme !== 'Sandbox'
    : isProductionEnvironment

  const finishAfterSave = () => {
    refetch()
    setItemIdForUpdate(undefined)
    setvariableD(undefined)
    if (closeFn) closeFn()
  }

  const showPaymentRegistrationResult = (hash: string) =>
    axios
      .get(`${INVOICE_URL}/payment-registrations/${hash}`)
      .then((response) => {
        setLoading(false)
        setPaymentRegistrationResult(response.data)
      })
      .catch(() => {
        // نتیجه بعداً در فرم صورتحساب دیده می‌شود؛ ذخیره انجام شده است
        finishAfterSave()
      })

  const retryPaymentRegistration = (registrationId: number) => {
    setRetryingRegistrationId(registrationId)
    axios
      .post(`${INVOICE_URL}/payment-registrations/${registrationId}/retry`)
      .then((response) => {
        const result: PaymentRegistrationResult = response.data
        setPaymentRegistrationResult((current) => (current ? result : current))
        setPayments((current) =>
          current.map((payment) => {
            const row = result.rows.find((x) => x.id === payment.id)
            return row
              ? {
                  ...payment,
                  locked: row.locked,
                  taxRegistration: {
                    status: row.status,
                    code: row.code,
                    message: row.message,
                    date: row.at,
                    registrationId: row.registrationId,
                    amount: row.registeredAmount,
                  },
                }
              : payment
          })
        )
      })
      .catch((error) => {
        setErrorAppLogId(getInvoiceErrorAppLogId(error))
        setErrorModal(
          getInvoiceErrorMessage(error, 'تلاش مجدد ثبت پرداخت در سامانه مؤدیان انجام نشد.')
        )
      })
      .finally(() => setRetryingRegistrationId(undefined))
  }

  const save = (
    execute: boolean,
    confirm: boolean,
    save: boolean,
    registrationConfirmed = false
  ) => {
    if (article9DraftError) {
      setErrorModal(article9DraftError)
      return
    }
    if (!registrationConfirmed && paymentsToRegister.length > 0) {
      setPaymentRegistrationConfirm({execute, confirm, save})
      return
    }
    if (!isReferralInvoice && !fiscalMemoryIdForSave && !isProformaForm) {
      setErrorModal('انتخاب شناسه یکتای حافظه مالیاتی برای ثبت صورتحساب الزامی است.')
      return
    }
    if (isProformaForm && !isNotEmpty(proformaValidUntil)) {
      setErrorModal('تاریخ اعتبار پیش‌فاکتور را انتخاب کنید.')
      return
    }
    const patternError = getPatternValidationError()
    if (effectiveSubject !== 3 && patternError !== '') {
      setErrorModal(patternError)
      return
    }
    if (invoiceRules?.enabled && invoiceRules.errors.length > 0) {
      setErrorModal(invoiceRules.errors.join('\n'))
      return
    }
    if (variableD === 4) {
      const returnQuantityError = getSalesReturnQuantityError(items, returnQty)
      if (returnQuantityError) {
        setErrorModal(returnQuantityError)
        return
      }
    }
    if (effectiveSubject !== 3 && unitRule.required) {
      const invalidUnitIndex = items.findIndex((item) => !hasOrganizationUnitCode(item.unit))
      if (invalidUnitIndex >= 0) {
        setErrorModal(
          `واحد اندازه‌گیری قلم شماره ${
            invalidUnitIndex + 1
          } الزامی است؛ واحدی را انتخاب کنید که کد معتبر سامانه مؤدیان داشته باشد.`
        )
        return
      }
    }

    if (template11 && effectiveSubject !== 3) {
      const template11Error =
        getTemplate11RowsError(items) || getTemplate11CashError(settlement, cash, getSumNetPrice())
      if (template11Error) {
        setErrorModal(template11Error)
        return
      }
    }

    if (
      effectiveSubject === 3 ||
      confirm ||
      returnQty.length == 0 ||
      getSumNetPrice() > 0 ||
      getSumReturnQtyRemain() > 0
    ) {
      setLoading(true)
      const submitItems = effectiveSubject === 3 ? [] : getRowsForSubmit(items)
      const submitReturnQty = effectiveSubject === 3 ? [] : getRowsForSubmit(returnQty)
      axios
        .post(`${INVOICE_URL}/update/${itemIdForUpdate || ''}`, {
          no: no,
          date: date,
          subject: isNewSubjectFlow ? invoiceSubject : undefined,
          sourceTaxId: isNewSubjectFlow && invoiceSubject !== 1 ? referenceTaxId : undefined,
          type: invoiceType != 1 ? 2 : 1,
          template: invoiceTemplate,
          webFormType: formType,
          buyer: buyer,
          buyerDescription: buyerDescription,
          contractCode: serializeRuleField('crn', contractCode),
          declarationNo: serializeRuleField('scln', declarationNo.trim()),
          officeCode: serializeRuleField('scc', officeCode.trim()),
          billNo: serializeRuleField('billid', billNo.trim()),
          cottageNo: serializeRuleField('cdcn', cottageNo.trim()),
          cottageDate: serializeRuleField('cdcd', cottageDate),
          saleAnnNo: serializeRuleField('asn', saleAnnNo.trim()),
          saleAnnDate: serializeRuleField('asd', saleAnnDate),
          insPolicyNo: serializeRuleField('in', insPolicyNo.trim()),
          extInsPolicyNo: serializeRuleField('an', extInsPolicyNo.trim()),
          flightInfo:
            invoiceTemplate == 6
              ? {
                  flightType: Number(flightType),
                  buyerMethod: Number(flightBuyerMethod),
                  nationalId: flightNationalId.trim(),
                  foreignId: flightForeignId.trim(),
                  passportNumber: flightPassportNumber.trim(),
                  firstName: flightFirstName.trim(),
                  lastName: flightLastName.trim(),
                  economicCode: flightEconomicCode.trim(),
                  agentName: flightAgentName.trim(),
                  agentEconomicCode: flightAgentEconomicCode.trim(),
                }
              : null,
          shipmentInfo:
            invoiceTemplate == 8
              ? {
                  blNumber: shipmentBlNumber.trim(),
                  refBlNumber: shipmentRefBlNumber.trim(),
                  originCountry: shipmentOriginCountry.trim(),
                  originCity: shipmentOriginCity.trim(),
                  destinationCountry: shipmentDestinationCountry.trim(),
                  destinationCity: shipmentDestinationCity.trim(),
                  senderEconomicCode: shipmentSenderEconomicCode.trim(),
                  receiverEconomicCode: shipmentReceiverEconomicCode.trim(),
                  transportType: shipmentTransportType,
                  fleetNumber: shipmentFleetNumber.trim(),
                  driverIdCode: shipmentDriverIdCode.trim(),
                  totalWeight: shipmentTotalWeight.trim(),
                  ShippedItems: items
                    .filter((item) => item.productId)
                    .map((item) => ({
                      Id: item.productId?.toString(),
                      Name: item.description || item.product?.nm,
                      stuffId: item.product?.sti,
                    })),
                }
              : null,
          items: submitItems,
          settlement: settlement,
          // فقط الگوی ۱۱ با روش تسویه ۳ سهم نقدی را مستقیم ارسال می‌کند (cap)؛ سایر الگوها مانند قبل
          cash: template11 && settlement == '3' ? Number(cash) : undefined,
          description: description,
          instructionVersion: invoiceRules?.enabled ? invoiceRules.instructionVersion : undefined,
          isArticle9: article9Request.isArticle9,
          indati2m: article9Request.indati2m,
          nti1: serializeRuleField('nti1', note1.trim() || undefined),
          nti2: serializeRuleField('nti2', note2.trim() || undefined),
          // پیش‌فاکتور پرداخت ندارد؛ پرداخت‌ها روی صورتحسابِ حاصل از تبدیل ثبت می‌شوند.
          payments: template11 || isProformaForm ? [] : payments,
          discounts: template11 ? [] : discounts,
          execute: execute,
          confirm: confirm,
          save: save,
          returnQty: submitReturnQty,
          action: variableD,
          files: files,
          isSend: isProformaForm
            ? false
            : !invoice?.id && !autoSendTouched
            ? defaultAutoSend
            : isSend,
          vatCheck: vatCheck,
          printTemplate: printTemplate,
          tax17: serializeRuleField('tax17', tax17 ? Number(tax17) : undefined),
          fiscalMemoryId: isReferralInvoice ? undefined : fiscalMemoryIdForSave,
          isProductionEnvironment: isReferralInvoice ? undefined : isProductionEnvironmentForSave,
          ...(isProformaForm
            ? {
                isProforma: true,
                isArticle9: false,
                indati2m: undefined,
                proformaValidUntil: proformaValidUntil,
                proformaPaymentTerms: proformaPaymentTerms.trim(),
                proformaDeliveryTerms: proformaDeliveryTerms.trim(),
              }
            : {}),
        })
        .then((response) => {
          // پرداخت جدید روی صورتحساب ارسال‌شده: نتیجهٔ ثبت در سامانه مؤدیان پیش از بستن نشان داده می‌شود
          if (paymentsToRegister.length > 0 && typeof response.data === 'string' && response.data) {
            showPaymentRegistrationResult(response.data)
            return
          }
          finishAfterSave()
        })
        .catch((error) => {
          setLoading(false)
          const status = error.response?.status
          if (status == 426) {
            setEbtalNewModal(true)
          } else if (status == 415) {
            setModifyModal(true)
          } else if (status == 409 && !save) {
            // بک‌اند قدیمی: تغییر پرداخت را با ۴۰۹ می‌پرسد؛ همان ذخیرهٔ درجا انجام می‌شود (ثبت در سامانه با بک‌اند جدید)
            saveInvoice(execute, confirm, true, true)
          } else {
            console.log(error.response)
            setErrorAppLogId(getInvoiceErrorAppLogId(error))
            setErrorModal(
              getInvoiceErrorMessage(error, 'ذخیره صورتحساب ناموفق بود. لطفاً دوباره تلاش کنید.')
            )
          }
        })
    } else {
      setEbtalModal(true)
    }
  }
  // داخل save پارامتر هم‌نامِ save تابع را می‌پوشاند؛ این نام برای فراخوانی دوبارهٔ خودِ تابع است
  const saveInvoice = (execute: boolean, confirm: boolean, inPlace: boolean, confirmed: boolean) =>
    save(execute, confirm, inPlace, confirmed)

  const selectReferenceCandidate = (candidate: TaxFolderReferenceCandidate) => {
    setReferenceTaxId(candidate.taxId)
    if (
      candidate.canLoadDetails &&
      candidate.invoiceHash &&
      (invoiceSubject === 2 || invoiceSubject === 4)
    ) {
      setvariableD(invoiceSubject === 2 ? 2 : 4)
      setItemIdForUpdate(candidate.invoiceHash)
    }
  }

  const showImportedPdfInvoice = (result: TaxFolderPdfConfirmResult) => {
    updateQueryState({
      invoiceSeason: 'all',
      filter: {search: result.taxId},
      page: 1,
      items_per_page: queryState.items_per_page,
    })
    setItemIdForUpdate(undefined)
    setvariableD(undefined)
    refetch()
    if (closeFn) closeFn()
  }

  const renderFiscalMemorySelector = () => {
    if (isReferralInvoice) return null
    // در «عملیات پرداخت» صورتحساب ارسال‌شده حافظهٔ مالیاتی قابل تغییر نیست و انتخابگرش نمایش داده نمی‌شود
    if (variableD === 5 && !!invoice?.fmi && invoice.fmce === false) return null

    const selectionDisabled =
      availableFiscalMemories.length <= 1 || (!!invoice?.id && invoice.fmce === false)

    return (
      <div className='card card-body mb-5 border border-dashed border-primary'>
        <label className='form-label fw-bold'>
          <FieldHelpLabel label='شناسه یکتای حافظه مالیاتی' helpKey='ui.fiscalMemory' isRequired />
        </label>
        <select
          className='form-select'
          value={effectiveFiscalMemoryId || ''}
          disabled={selectionDisabled}
          onChange={(event) => {
            const selectedId = Number(event.target.value) || undefined
            setFiscalMemoryId(selectedId)
            const selectedToken = fiscalMemories.find((token) => token.id === selectedId)
            if (selectedToken) setIsProductionEnvironment(selectedToken.isActive !== false)
          }}
        >
          {!availableFiscalMemories.length && (
            <option value=''>حافظه مالیاتی منطبق یافت نشد</option>
          )}
          {!!availableFiscalMemories.length && !effectiveFiscalMemoryId && (
            <option value='' disabled>
              شناسه یکتای حافظه مالیاتی را انتخاب کنید
            </option>
          )}
          {availableFiscalMemories.map((token) => (
            <option key={token.id} value={token.id} disabled={token.isEnabled === false}>
              [{token.isActive === false ? 'سندباکس' : 'عملیاتی'}]{' '}
              {token.title || token.name || 'حافظه مالیاتی'} — {token.taxid || token.uniqueTaxId}
              {token.isDefault ? ' (پیش‌فرض)' : ''}
            </option>
          ))}
        </select>
        {invoice?.id && invoice.fmce === false && (
          <div className='text-danger mt-2'>
            {invoice.fmcr || 'این صورتحساب در وضعیت قابل تغییر نیست.'}
          </div>
        )}
        {invoice?.id && invoice.fmce !== false && effectiveFiscalMemoryId !== invoice.fmi && (
          <div className='text-warning mt-2'>
            با ذخیره صورتحساب، TaxId بر اساس شناسه انتخاب‌شده تغییر خواهد کرد.
          </div>
        )}
      </div>
    )
  }

  const renderInvoiceRules = () =>
    variableD !== 5 ? (
      <InvoiceRulesV79Panel
        rules={invoiceRules}
        loading={invoiceRulesLoading}
        error={invoiceRulesError}
        itemCount={items.length}
        isArticle9={isArticle9}
        registeredDateTime={article9Request.indati2m}
      />
    ) : null

  const renderSubjectAndRules = () => {
    if (variableD === 5) return null

    if (isNewSubjectFlow) {
      return (
        <InvoiceSubjectSelector
          subject={invoiceSubject}
          setSubject={setInvoiceSubject}
          invoiceType={invoiceType}
          referenceTaxId={referenceTaxId}
          setReferenceTaxId={setReferenceTaxId}
          onReferenceOwnershipChange={setReferenceOwnershipValid}
          onSelectCandidate={selectReferenceCandidate}
          onPdfImported={showImportedPdfInvoice}
          allowedSubjects={
            invoiceRules?.enabled
              ? invoiceRules.allowedSubjects
              : template11
              ? TEMPLATE_11_ALLOWED_SUBJECTS
              : undefined
          }
          rulesContent={renderInvoiceRules()}
        />
      )
    }

    return (
      <section className='mp-invoice-subject-card is-expanded mb-5'>
        <div className='mp-invoice-subject-card__body'>
          <div className='mp-invoice-subject-card__heading'>
            <div>
              <h3>
                <FieldHelpLabel label='موضوع صورتحساب' helpKey='header.ins' />
              </h3>
              <p>
                {effectiveSubject === 2
                  ? 'اصلاحی'
                  : effectiveSubject === 3
                  ? 'ابطالی'
                  : effectiveSubject === 4
                  ? 'برگشت از فروش'
                  : 'اصلی'}
              </p>
            </div>
            <span className='badge badge-light-primary'>فقط‌خواندنی</span>
          </div>
          {renderInvoiceRules()}
        </div>
      </section>
    )
  }

  return (
    <>
      <FieldHelpResolverScope resolver={fieldHelpResolver} />
      {!first && (
        <>
          {isNewSubjectFlow && invoiceSubject === 3 && (
            <>
              {renderSubjectAndRules()}
              <InvoiceCancellationPanel
                date={date}
                setDate={setDate}
                description={description}
                setDescription={setDescription}
                now={now}
                loading={loading}
                canSave={
                  isNotEmpty(no) && isNotEmpty(date) && referenceIsValid && !article9DraftError
                }
                onSave={() => save(false, false, false)}
                invoiceType={invoiceType}
                isArticle9={isArticle9}
                setIsArticle9={setIsArticle9}
                registrationDateTime={article9RegistrationDateTime}
                setRegistrationDateTime={setArticle9RegistrationDateTime}
              />
              {renderFiscalMemorySelector()}
            </>
          )}
          {variableD == 5 && (
            <Stepper
              validate={!loading && validate3}
              indicator={false}
              save={() => {
                save(false, false, false)
              }}
              // saveExecute={() => {
              //   save(true, false, false)
              // }}
              steps={[
                {
                  icon: '1',
                  name: 'روش تسویه',
                  content: (
                    <>
                      <Step3
                        settlement={{settlement: settlement, setSettlement: setSettlement}}
                        payments={{payments: payments, setPayments: setPayments}}
                        getSumPayments={getSumPayments}
                        getSumNetPrice={getSumNetPrice}
                        invoiceDate={date}
                        invoiceType={{
                          invoiceType: invoiceType,
                          setInvoiceType: setInvoiceType,
                        }}
                        totalVatRate={totalVatRate}
                        paymentRegistration={invoice?.pytx}
                        settlementReadOnly={settlementReadOnly}
                        paymentsToRegisterCount={paymentsToRegister.length}
                        onRetryRegistration={retryPaymentRegistration}
                        retryingRegistrationId={retryingRegistrationId}
                        invoiceTemplate={invoiceTemplate}
                        cash={{cash: cash, setCash: setCash}}
                      />
                      {renderFiscalMemorySelector()}
                    </>
                  ),
                  validate: validate3,
                },
              ]}
            />
          )}
          {variableD == 4 && (
            <Stepper
              validate={!loading && validateReturn && isNotEmpty(date) && !article9DraftError}
              indicator={false}
              showPrevious={false}
              save={() => {
                save(false, false, false)
              }}
              // saveExecute={() => {
              //   save(true, false, false)
              // }}
              steps={[
                {
                  icon: '1',
                  name: 'اقلام صورتحساب',
                  content: (
                    <>
                      <div className='row mb-7'>
                        <div className='col-12 col-lg-6'>
                          <CustomInputs
                            type='datepicker'
                            label={<>تاریخ و زمان صدور صورتحساب برگشت از فروش</>}
                            labelAccessory={
                              <InvoiceArticle9IssueDateAccessory
                                invoiceType={invoiceType}
                                issueDateTime={date}
                                isArticle9={isArticle9}
                                setIsArticle9={setIsArticle9}
                              />
                            }
                            isRequired
                            timePicker
                            limitFromDate={minimumReferenceDate}
                            stateValue={{value: date, setValue: setDate}}
                            limitToDate={now}
                            hint={minimumReferenceDate ? REFERENCED_INVOICE_DATE_HINT : undefined}
                          />
                        </div>
                        {(isArticle9 || invoiceType === 3) && (
                          <div className='col-12 col-lg-6'>
                            <InvoiceArticle9RegistrationField
                              invoiceType={invoiceType}
                              issueDateTime={date}
                              now={now}
                              isArticle9={isArticle9}
                              setIsArticle9={setIsArticle9}
                              registrationDateTime={article9RegistrationDateTime}
                              setRegistrationDateTime={setArticle9RegistrationDateTime}
                            />
                          </div>
                        )}
                      </div>
                      <Step2
                        items={{items: items, setItems: setItems}}
                        returnQty={{returnQty: returnQty, setReturnQty: setReturnQty}}
                        discounts={{discounts: discounts, setDiscounts: setDiscounts}}
                        getSumAdPrice={getSumAdPrice}
                        getSumAdPriceEXDiscount={getSumAdPriceEXDiscount}
                        getSumDiscount={getSumDiscount}
                        getSumItemDiscount={getSumItemDiscount}
                        getSumItemTotalDiscount={getSumItemTotalDiscount}
                        getSumNetPrice={getSumNetPrice}
                        getSumPrice={getSumPrice}
                        getSumTaxPrice={getSumTaxPrice}
                        getSumVatPrice={getSumVatPrice}
                        updateItemsKey={updateItemsKey}
                        invoiceTemplate={invoiceTemplate}
                        invoiceType={invoiceType}
                        invoiceSubject={effectiveSubject}
                        invoiceDate={date}
                        formType={formType}
                        tax17={{tax17: tax17, setTax17: setTax17}}
                        rowPolicy={activeRowPolicy}
                        rules={invoiceRules}
                        productionInvoice={
                          isReferralInvoice ? undefined : isProductionEnvironmentForSave
                        }
                      />
                      {isCompleteSalesReturn && (
                        <div className='alert alert-warning d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4 mt-6'>
                          <div>
                            <strong className='d-block mb-1'>
                              برگشت کامل با این فرم مجاز نیست
                            </strong>
                            <span>
                              وقتی همه اقلام به‌طور کامل برگشت داده می‌شوند، باید صورتحساب ابطالی
                              صادر کنید.
                            </span>
                          </div>
                          <button
                            type='button'
                            className='btn btn-danger flex-shrink-0'
                            onClick={openCancellationFromSalesReturn}
                          >
                            <i className='las la-ban fs-2 me-1'></i>
                            صدور صورتحساب ابطالی
                          </button>
                        </div>
                      )}
                      {renderFiscalMemorySelector()}
                    </>
                  ),
                  validate: validate2 && isNotEmpty(date) && !article9DraftError,
                },
              ]}
            />
          )}
          {(variableD == undefined || variableD < 4) &&
            !(isNewSubjectFlow && invoiceSubject === 3) && (
              <Stepper
                validate={
                  !loading &&
                  validate1 &&
                  validate2 &&
                  validate3 &&
                  referenceIsValid &&
                  !article9DraftError &&
                  proformaValid
                }
                save={() => {
                  save(false, false, false)
                }}
                // saveExecute={() => {
                //   save(true, false, false)
                // }}
                steps={[
                  {
                    icon: '1',
                    name: 'سرآمد صورتحساب',
                    content: (
                      <>
                        {renderSubjectAndRules()}
                        {isProformaForm && !invoice?.id && Number(currentUser?.cpi || 0) > 0 && (
                          <ServiceFeeLine
                            companyId={Number(currentUser?.cpi)}
                            feature='proforma'
                            each='این پیش‌فاکتور'
                            className='mb-4'
                          />
                        )}
                        {/* A referral is a value-added service of its own (2026-10-18). */}
                        {referralFee && Number(currentUser?.cpi || 0) > 0 && (
                          <ServiceFeeLine
                            companyId={Number(currentUser?.cpi)}
                            feature={referralFee.feature}
                            each={referralFee.each}
                            className='mb-4'
                          />
                        )}
                        {isProformaForm && (
                          <ProformaFormFields
                            issueDate={date}
                            defaultValidityDays={proformaSettings?.defaultValidityDays}
                            validUntil={{value: proformaValidUntil, setValue: setProformaValidUntil}}
                            paymentTerms={{
                              value: proformaPaymentTerms,
                              setValue: setProformaPaymentTerms,
                            }}
                            deliveryTerms={{
                              value: proformaDeliveryTerms,
                              setValue: setProformaDeliveryTerms,
                            }}
                          />
                        )}
                        <Step1
                          proforma={isProformaForm}
                          invoice={invoice}
                          invoiceType={{
                            invoiceType: invoiceType,
                            setInvoiceType: setInvoiceType,
                          }}
                          invoiceTemplate={invoiceTemplate}
                          no={{no: no, setNo: setNo}}
                          fiscalMemoryId={effectiveFiscalMemoryId}
                          buyerDescription={{
                            buyerDescription: buyerDescription,
                            setBuyerDescription: setBuyerDescription,
                          }}
                          buyer={{buyer: buyer, setBuyer: setBuyer}}
                          date={{date: date, setDate: setDate}}
                          now={now}
                          rules={invoiceRules}
                          // ماده ۹ موضوع صورتحساب است، نه پیش‌فاکتور.
                          article9={
                            isProformaForm
                              ? undefined
                              : {
                                  isArticle9,
                                  setIsArticle9,
                                  registrationDateTime: article9RegistrationDateTime,
                                  setRegistrationDateTime: setArticle9RegistrationDateTime,
                                }
                          }
                          contractCode={{
                            contractCode: contractCode,
                            setContractCode: setContractCode,
                          }}
                          stockExchangeInfo={{
                            saleAnnNo: saleAnnNo,
                            setSaleAnnNo: setSaleAnnNo,
                            saleAnnDate: saleAnnDate,
                            setSaleAnnDate: setSaleAnnDate,
                          }}
                          patternFields={{
                            declarationNo: {value: declarationNo, setValue: setDeclarationNo},
                            officeCode: {value: officeCode, setValue: setOfficeCode},
                            billNo: {value: billNo, setValue: setBillNo},
                            cottageNo: {value: cottageNo, setValue: setCottageNo},
                            cottageDate: {value: cottageDate, setValue: setCottageDate},
                            insPolicyNo: {value: insPolicyNo, setValue: setInsPolicyNo},
                            extInsPolicyNo: {value: extInsPolicyNo, setValue: setExtInsPolicyNo},
                            flightType: {value: flightType, setValue: setFlightType},
                            flightBuyerMethod: {
                              value: flightBuyerMethod,
                              setValue: setFlightBuyerMethod,
                            },
                            flightNationalId: {
                              value: flightNationalId,
                              setValue: setFlightNationalId,
                            },
                            flightForeignId: {
                              value: flightForeignId,
                              setValue: setFlightForeignId,
                            },
                            flightPassportNumber: {
                              value: flightPassportNumber,
                              setValue: setFlightPassportNumber,
                            },
                            flightFirstName: {
                              value: flightFirstName,
                              setValue: setFlightFirstName,
                            },
                            flightLastName: {value: flightLastName, setValue: setFlightLastName},
                            flightEconomicCode: {
                              value: flightEconomicCode,
                              setValue: setFlightEconomicCode,
                            },
                            flightAgentName: {
                              value: flightAgentName,
                              setValue: setFlightAgentName,
                            },
                            flightAgentEconomicCode: {
                              value: flightAgentEconomicCode,
                              setValue: setFlightAgentEconomicCode,
                            },
                            shipmentBlNumber: {
                              value: shipmentBlNumber,
                              setValue: setShipmentBlNumber,
                            },
                            shipmentRefBlNumber: {
                              value: shipmentRefBlNumber,
                              setValue: setShipmentRefBlNumber,
                            },
                            shipmentOriginCountry: {
                              value: shipmentOriginCountry,
                              setValue: setShipmentOriginCountry,
                            },
                            shipmentOriginCity: {
                              value: shipmentOriginCity,
                              setValue: setShipmentOriginCity,
                            },
                            shipmentDestinationCountry: {
                              value: shipmentDestinationCountry,
                              setValue: setShipmentDestinationCountry,
                            },
                            shipmentDestinationCity: {
                              value: shipmentDestinationCity,
                              setValue: setShipmentDestinationCity,
                            },
                            shipmentSenderEconomicCode: {
                              value: shipmentSenderEconomicCode,
                              setValue: setShipmentSenderEconomicCode,
                            },
                            shipmentReceiverEconomicCode: {
                              value: shipmentReceiverEconomicCode,
                              setValue: setShipmentReceiverEconomicCode,
                            },
                            shipmentTransportType: {
                              value: shipmentTransportType,
                              setValue: setShipmentTransportType,
                            },
                            shipmentFleetNumber: {
                              value: shipmentFleetNumber,
                              setValue: setShipmentFleetNumber,
                            },
                            shipmentDriverIdCode: {
                              value: shipmentDriverIdCode,
                              setValue: setShipmentDriverIdCode,
                            },
                            shipmentTotalWeight: {
                              value: shipmentTotalWeight,
                              setValue: setShipmentTotalWeight,
                            },
                          }}
                        />
                      </>
                    ),
                    validate: validate1 && referenceIsValid && !article9DraftError && proformaValid,
                  },
                  {
                    icon: '2',
                    name: 'اقلام صورتحساب',
                    content: (
                      <>
                        <Step2
                          items={{items: items, setItems: setItems}}
                          returnQty={{returnQty: returnQty, setReturnQty: setReturnQty}}
                          discounts={{discounts: discounts, setDiscounts: setDiscounts}}
                          getSumAdPrice={getSumAdPrice}
                          getSumAdPriceEXDiscount={getSumAdPriceEXDiscount}
                          getSumDiscount={getSumDiscount}
                          getSumItemDiscount={getSumItemDiscount}
                          getSumItemTotalDiscount={getSumItemTotalDiscount}
                          getSumNetPrice={getSumNetPrice}
                          getSumPrice={getSumPrice}
                          getSumTaxPrice={getSumTaxPrice}
                          getSumVatPrice={getSumVatPrice}
                          updateItemsKey={updateItemsKey}
                          invoiceTemplate={invoiceTemplate}
                          invoiceType={invoiceType}
                          invoiceSubject={effectiveSubject}
                          invoiceDate={date}
                          formType={formType}
                          tax17={{tax17: tax17, setTax17: setTax17}}
                          rowPolicy={activeRowPolicy}
                          rules={invoiceRules}
                          productionInvoice={
                            isReferralInvoice ? undefined : isProductionEnvironmentForSave
                          }
                        />
                      </>
                    ),
                    validate: validate2,
                  },
                  {
                    icon: '3',
                    name: 'روش تسویه',
                    content: (
                      <Step3
                        settlement={{settlement: settlement, setSettlement: setSettlement}}
                        payments={{payments: payments, setPayments: setPayments}}
                        getSumPayments={getSumPayments}
                        getSumNetPrice={getSumNetPrice}
                        invoiceDate={date}
                        totalVatRate={totalVatRate}
                        invoiceType={{
                          invoiceType: invoiceType,
                          setInvoiceType: setInvoiceType,
                        }}
                        paymentRegistration={variableD === 2 ? undefined : invoice?.pytx}
                        settlementReadOnly={settlementReadOnly}
                        paymentsToRegisterCount={paymentsToRegister.length}
                        onRetryRegistration={retryPaymentRegistration}
                        retryingRegistrationId={retryingRegistrationId}
                        invoiceTemplate={invoiceTemplate}
                        cash={{cash: cash, setCash: setCash}}
                        hidePayments={isProformaForm}
                      />
                    ),
                    validate: validate3,
                  },
                  {
                    icon: invoiceType == 2 ? '3' : '4',
                    name: 'مستندات',
                    content: (
                      <>
                        <Step4
                          // پیش‌فاکتور ارسال نمی‌شود؛ گزینهٔ ارسال مستقیم برایش نیست.
                          isNew={isNew && !isProformaForm}
                          description={{description: description, setDescription: setDescription}}
                          getSumPayments={getSumPayments}
                          getSumNetPrice={getSumNetPrice}
                          invoiceDate={date}
                          files={{files: files, setFiles: setFiles}}
                          isSend={{
                            isSend: displayedIsSend,
                            setIsSend: setIsSendFromControl,
                          }}
                          vatCheck={{vatCheck: vatCheck, setVatCheck: setVatCheck}}
                          showVatRateValidationQuestion={showVatRateValidationQuestion}
                          rules={invoiceRules}
                          notes={{note1, setNote1, note2, setNote2}}
                          readOnly={invoice?.fmce === false}
                          printTemplate={{
                            printTemplate: printTemplate,
                            setPrintTemplate: setPrintTemplate,
                          }}
                        />
                        {!isProformaForm && renderFiscalMemorySelector()}
                      </>
                    ),
                    validate: true,
                  },
                ]}
              />
            )}
          {ebtalNewModal && (
            <Alert
              icon='la-exclamation-triangle'
              type='danger'
              title='توجه'
              body={
                <p className='text-gray-600 fs-4'>
                  برای تغییر این اطلاعات، باید صورتحساب را ابطال کنید. برای این کار، از ستون عملیات
                  در جدول، گزینه «ابطال» را انتخاب کنید.
                </p>
              }
              cancel={{
                text: 'انصراف',
                fn: () => {
                  setEbtalNewModal(false)
                },
              }}
              // ok={{
              //   text: 'تایید',
              //   fn: () => {
              //     setEbtalNewModal(false)
              //     save(false, true)
              //   },
              // }}
            />
          )}
          {modifyModal && (
            <Alert
              icon='la-info'
              title=''
              body={
                <p className='text-gray-600 fs-4'>
                  مطابق دستورالعمل سامانه مؤدیان، تغییراتی که در صورتحساب خود اعمال کرده‌اید منجر به
                  صدور <span className='text-gray-800 fw-bolder mx-2'>صورتحساب اصلاحی</span> خواهد
                  شد.
                </p>
              }
              type='warning'
              cancel={{
                text: 'انصراف',
                fn: () => {
                  setModifyModal(false)
                },
              }}
              ok={{
                text: 'تایید',
                fn: () => {
                  setModifyModal(false)
                  save(false, true, false)
                },
              }}
            />
          )}
          {ebtalModal && (
            <Alert
              icon='la-exclamation-triangle'
              title='توجه'
              type='danger'
              body={
                <p className='text-gray-600 fs-4'>
                  با توجه به برگشت تمام اقلام، صورتحساب شما{' '}
                  <span className='text-gray-800 fw-bolder mx-2'>ابطال</span> خواهد شد.
                </p>
              }
              cancel={{
                text: 'انصراف',
                fn: () => {
                  setEbtalModal(false)
                },
              }}
              // ok={{
              //   text: 'تایید',
              //   fn: () => {
              //     setEbtalModal(false)
              //     save(false, true)
              //   },
              // }}
            />
          )}
          {paymentRegistrationConfirm && (
            <Alert
              icon='la-cloud-upload-alt'
              type='info'
              title='ثبت پرداخت در سامانه مؤدیان'
              body={
                <div className='text-gray-700 fs-5' style={{textAlign: 'justify'}}>
                  <p>
                    با ذخیره، {numberWithCommas(paymentsToRegister.length)} پرداخت جدید به مبلغ{' '}
                    <span className='fw-bold text-gray-900'>
                      {numberWithCommas(
                        paymentsToRegister.reduce(
                          (sum, payment) => sum + (Number(payment.price) || 0),
                          0
                        )
                      )}{' '}
                      ریال
                    </span>{' '}
                    برای این صورتحساب در کارپوشهٔ سامانه مؤدیان ثبت می‌شود و در {projectName} هم
                    ذخیره خواهد شد.
                  </p>
                  <p>
                    مبلغ ثبت در کارپوشه{' '}
                    <span className='fw-bold text-gray-900'>
                      {numberWithCommas(sumPaymentRegisteredAmounts(paymentsToRegister))} ریال
                    </span>{' '}
                    است: سهم بدون مالیات بر ارزش افزوده؛ کارپوشه سهم مالیات را خودش روی آن حساب
                    می‌کند و مبلغ کامل را نشان می‌دهد.
                  </p>
                  <p className='mb-0'>
                    پرداختی که در سامانه ثبت شود دیگر قابل ویرایش یا حذف نیست؛ مبلغ، تاریخ و روش
                    پرداخت را پیش از تأیید کنترل کنید.
                  </p>
                </div>
              }
              cancel={{
                text: 'انصراف',
                fn: () => setPaymentRegistrationConfirm(undefined),
              }}
              ok={{
                text: 'ثبت و ارسال به سامانه',
                type: 'btn-success',
                fn: () => {
                  const pending = paymentRegistrationConfirm
                  setPaymentRegistrationConfirm(undefined)
                  setPaymentRegistrationProgress({
                    count: paymentsToRegister.length,
                    amount: paymentsToRegister.reduce(
                      (sum, payment) => sum + (Number(payment.price) || 0),
                      0
                    ),
                    registeredAmount: sumPaymentRegisteredAmounts(paymentsToRegister),
                  })
                  save(pending.execute, pending.confirm, pending.save, true)
                },
              }}
            />
          )}
          {paymentRegistrationProgress && loading && !paymentRegistrationResult && (
            <Alert
              icon='la-cloud-upload-alt'
              type='info'
              help={false}
              title='در حال ثبت پرداخت در سامانه مؤدیان'
              body={
                <div className='text-gray-700 fs-5 text-center'>
                  <div
                    className='d-flex justify-content-center mb-5'
                    role='status'
                    aria-live='polite'
                  >
                    <span
                      className='spinner-border text-info'
                      style={{width: '3rem', height: '3rem'}}
                    ></span>
                  </div>
                  <p>
                    صورتحساب ذخیره می‌شود و {numberWithCommas(paymentRegistrationProgress.count)}{' '}
                    پرداخت به مبلغ{' '}
                    <span className='fw-bold text-gray-900'>
                      {numberWithCommas(paymentRegistrationProgress.amount)} ریال
                    </span>{' '}
                    به سامانه مؤدیان فرستاده می‌شود (مبلغ ثبت در کارپوشه بدون مالیات:{' '}
                    {numberWithCommas(paymentRegistrationProgress.registeredAmount)} ریال).
                  </p>
                  <p className='mb-0 text-gray-600'>
                    پاسخ سامانه معمولاً چند ثانیه طول می‌کشد و ممکن است تا حدود ۳۰ ثانیه برسد؛ لطفاً
                    این صفحه را نبندید. اگر سامانه پاسخ ندهد، ثبت به‌صورت خودکار ادامه می‌یابد و
                    نتیجه در فرم و تاریخچهٔ صورتحساب دیده می‌شود.
                  </p>
                </div>
              }
            />
          )}
          {paymentRegistrationResult && (
            <Alert
              icon={
                paymentRegistrationResult.rejected +
                  paymentRegistrationResult.unknown +
                  paymentRegistrationResult.exhausted >
                0
                  ? 'la-exclamation-triangle'
                  : 'la-check-double'
              }
              type={
                paymentRegistrationResult.rejected +
                  paymentRegistrationResult.unknown +
                  paymentRegistrationResult.exhausted >
                0
                  ? 'warning'
                  : 'success'
              }
              size='xl'
              title='نتیجهٔ ثبت پرداخت در سامانه مؤدیان'
              body={
                <div className='text-gray-700 fs-6 w-100'>
                  <p className='fs-5'>
                    صورتحساب ذخیره شد.{' '}
                    {paymentRegistrationResult.registered > 0 &&
                      `${numberWithCommas(
                        paymentRegistrationResult.registered
                      )} پرداخت در سامانه ثبت شد. `}
                    {paymentRegistrationResult.queued > 0 &&
                      `${numberWithCommas(
                        paymentRegistrationResult.queued
                      )} پرداخت در صف تلاش مجدد خودکار است. `}
                    {paymentRegistrationResult.rejected > 0 &&
                      `${numberWithCommas(
                        paymentRegistrationResult.rejected
                      )} پرداخت را سازمان رد کرد. `}
                    {paymentRegistrationResult.unknown > 0 &&
                      `نتیجهٔ ${numberWithCommas(
                        paymentRegistrationResult.unknown
                      )} پرداخت نامشخص است. `}
                    {paymentRegistrationResult.exhausted > 0 &&
                      `ثبت ${numberWithCommas(
                        paymentRegistrationResult.exhausted
                      )} پرداخت ناموفق ماند. `}
                  </p>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed align-middle fs-7 mb-0'>
                      <thead>
                        <tr className='fw-bold text-gray-600'>
                          <th>روش پرداخت</th>
                          <th className='text-center'>مبلغ (ریال)</th>
                          <th className='text-center'>تاریخ پرداخت</th>
                          <th className='text-center'>وضعیت در سامانه</th>
                          <th className='text-center'>عملیات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentRegistrationResult.rows
                          .filter((row) => row.status != null)
                          .map((row) => {
                            const badge = getPaymentTaxRegistrationBadge(
                              {
                                status: row.status,
                                code: row.code,
                                message: row.message,
                                date: row.at,
                                registrationId: row.registrationId,
                              },
                              row.locked
                            )
                            return (
                              <tr key={row.id}>
                                <td>
                                  {InvoicePaymentTypeItems.find(
                                    (item) => item.value === String(row.type)
                                  )?.label || 'پرداخت'}
                                </td>
                                <td className='text-center'>{numberWithCommas(row.price)}</td>
                                <td className='text-center englishText' dir='ltr'>
                                  {row.datetime || '—'}
                                </td>
                                <td className='text-center'>
                                  {badge && (
                                    <span className={`badge ${badge.className}`}>
                                      <i className={`las ${badge.icon}`} aria-hidden='true'></i>
                                      {badge.label}
                                    </span>
                                  )}
                                  {badge?.message && (
                                    <div
                                      className='text-gray-700 mt-1'
                                      style={{textAlign: 'justify'}}
                                    >
                                      {badge.message}
                                    </div>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {badge?.canRetry && row.registrationId && (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-light-warning'
                                      disabled={retryingRegistrationId === row.registrationId}
                                      title={
                                        badge.retryNeedsCheck
                                          ? 'پیش از تلاش مجدد، کارپوشه را بررسی کنید'
                                          : 'تلاش مجدد ثبت در سامانه مؤدیان'
                                      }
                                      onClick={() =>
                                        row.registrationId &&
                                        retryPaymentRegistration(row.registrationId)
                                      }
                                    >
                                      <i
                                        className={`las ${
                                          retryingRegistrationId === row.registrationId
                                            ? 'la-spinner la-spin'
                                            : 'la-redo-alt'
                                        }`}
                                        aria-hidden='true'
                                      ></i>
                                      تلاش مجدد
                                    </button>
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                  </div>
                  {paymentRegistrationResult.rows.some(
                    (row) => row.status === PaymentTaxRegistrationState.Unknown
                  ) && (
                    <p className='mt-4 mb-0 fw-bold'>
                      برای پرداخت با نتیجهٔ نامشخص، ابتدا کارپوشه را بررسی کنید؛ اگر پرداخت ثبت نشده
                      بود، «تلاش مجدد» بزنید تا دوبار ثبت نشود.
                    </p>
                  )}
                </div>
              }
              ok={{
                text: 'بستن',
                type: 'btn-success',
                fn: () => {
                  setPaymentRegistrationResult(undefined)
                  finishAfterSave()
                },
              }}
            />
          )}
          {errorModal != '' && (
            <Alert
              icon='la-exclamation-triangle'
              title='خطا'
              body={
                <WebInvoiceErrorSupportAction
                  errorMessage={errorModal}
                  formType={formType}
                  invoiceType={invoiceType}
                  invoiceTemplate={invoiceTemplate}
                  invoiceNumber={no}
                  invoice={invoice}
                  appLogId={errorAppLogId}
                  onNavigate={() => {
                    setErrorModal('')
                    setErrorAppLogId(undefined)
                  }}
                />
              }
              cancel={{
                text: 'بستن',
                fn: () => {
                  setErrorModal('')
                  setErrorAppLogId(undefined)
                },
              }}
            />
          )}
        </>
      )}
      {first && <>...</>}
    </>
  )
}

export {InvoiceForm}
